import { TagIcon } from 'lucide-react'

import { Body } from './Body'

import type { Announcement } from '../types'

export const vehiclePriceAnnouncement: Announcement = {
  version: '3.1.1',
  date: '2026-09-02',
  title: 'Permiso para modificar el precio',
  summary: 'Viene habilitado para todos; se quita desde Usuarios, en el perfil de cada persona.',
  icon: TagIcon,
  Body,
}
